import algoliasearch from "algoliasearch/lite";

const ALGOLIA_API_KEY = "281f19d330b4e6350a408a429839b3bd";
const ALGOLIA_APP_ID = "4HMMQB7YDD";
export const ALGOLIA_FAQ_INDEX_NAME = "live";
export const ALGOLIA_HITS_PER_PAGE = 10;

export const searchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_API_KEY);
